import React from 'react';
import { CheckCheck, Phone, Video, MoreVertical } from 'lucide-react';

// WhatsApp Chat Mockup Component
export const WhatsAppChat = ({ 
  messages, 
  contactName = "Forest Villa Resort",
  contactStatus = "online",
  showHeader = true,
  className = ""
}) => {
  return (
    <div className={`whatsapp-chat w-full max-w-md ${className}`} data-testid="whatsapp-chat">
      {showHeader && (
        <div className="whatsapp-header">
          <div className="w-10 h-10 rounded-full bg-slate-200 border border-black/5 flex items-center justify-center overflow-hidden">
            <img 
              src="/villa-icon.webp" 
              alt="Forest Villa Resort" 
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-1">
            <h4 className="text-slate-900 text-sm font-bold tracking-tight font-['Lexend']">{contactName}</h4>
            <div className="flex items-center gap-1.5">
              <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
              <p className="text-[10px] text-slate-500 font-bold uppercase tracking-wider">{contactStatus}</p>
            </div>
          </div>
          <div className="flex items-center gap-4 text-slate-400">
            <Video className="w-5 h-5 cursor-pointer hover:text-cyan-600 transition-colors" />
            <Phone className="w-5 h-5 cursor-pointer hover:text-cyan-600 transition-colors" />
            <MoreVertical className="w-5 h-5 cursor-pointer hover:text-cyan-600 transition-colors" />
          </div>
        </div>
      )}
      
      <div className="whatsapp-body space-y-1">
        {messages.map((msg, index) => (
          <div 
            key={index}
            className={`wa-bubble ${msg.isUser ? 'wa-bubble-user' : 'wa-bubble-agent'}`}
            data-testid={`chat-message-${index}`}
          >
            <p className="whitespace-pre-line font-medium text-[0.85rem]">{msg.text}</p>
            <div className="wa-time">
              <span className="font-medium">{msg.time || '10:30'}</span>
              {msg.isUser && (
                <CheckCheck className="w-4 h-4 wa-check" />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Simplified Owner Chat variant
export const OwnerChat = ({ messages, className = "" }) => {
  return (
    <div className={`whatsapp-chat w-full max-w-md ${className}`} data-testid="owner-chat">
      <div className="whatsapp-header">
        <div className="w-10 h-10 rounded-full bg-cyan-600 flex items-center justify-center">
          <span className="text-white font-bold text-sm">S</span>
        </div>
        <div className="flex-1">
          <h4 className="text-slate-900 text-sm font-bold tracking-tight">Sagent Dashboard</h4>
          <p className="text-[10px] text-slate-500 font-bold uppercase tracking-wider">AI Assistant</p>
        </div>
      </div>
      
      <div className="whatsapp-body space-y-1">
        {messages.map((msg, index) => (
          <div 
            key={index}
            className={`wa-bubble ${msg.isOwner ? 'wa-bubble-user' : 'wa-bubble-agent'}`}
          >
            <p className="whitespace-pre-line font-medium text-[0.85rem]">{msg.text}</p>
            <div className="wa-time">
              <span className="font-medium">{msg.time || '14:22'}</span>
              {msg.isOwner && <CheckCheck className="w-4 h-4 wa-check" />}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhatsAppChat;
